import { useParams, Link, Navigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return <Navigate to="/" replace />;
  }

  const articles = getArticlesByCategory(slug!);

  return (
    <div className="min-h-screen pt-16">
      {/* Header */}
      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />
          <div className="mt-6">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              {category.name}
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-2xl">
              {category.description}
            </p>
            <div className="mt-2 text-xs text-foreground-400">
              共 {articles.length} 篇文章
            </div>
          </div>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="py-6 px-4 md:px-6 bg-background-50 border-b border-background-200/70">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Article List */}
      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
        <div className="max-w-6xl mx-auto">
          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
                <i className="ri-inbox-line text-2xl text-foreground-400" />
              </div>
              <p className="text-foreground-500">该分类暂无文章</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}